import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookieConsent");
    if (!consent) {
      setVisible(true);
      document.body.style.overflow = "hidden"; // Lock scroll
    }
  }, []);

  const handleResponse = (accepted) => {
    localStorage.setItem("cookieConsent", accepted ? "accepted" : "declined");
    setVisible(false);
    document.body.style.overflow = "auto"; // Restore scroll
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          className="fixed inset-0 bg-black/40 backdrop-blur-sm z-[100] flex items-center justify-center px-4"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <motion.div
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.9, opacity: 0 }}
            transition={{ duration: 0.4 }}
            className="bg-white p-8 rounded-2xl shadow-lg max-w-md w-full text-center font-[chivo]"
          >
            <h3 className="text-xl font-semibold mb-4 text-[#009FB7]">🍪 Consenso Cookie</h3>
            <p className="text-gray-700 mb-6 text-sm">
              Utilizziamo i cookie per migliorare la tua esperienza. Accettando, ci aiuti a offrirti un servizio migliore.
            </p>

            <div className="flex justify-center gap-4">
              <button
                onClick={() => handleResponse(true)}
                className="px-6 py-2 bg-[#009FB7] text-white rounded-full hover:bg-[#00b8c0] transition"
              >
                Accetta
              </button>
              <button
                onClick={() => handleResponse(false)}
                className="px-6 py-2 border border-[#009FB7] text-[#009FB7] rounded-full hover:bg-[#009FB7] hover:text-white transition"
              >
                Rifiuta
              </button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CookieConsent;
